export default __webpack_public_path__ + "2e53cbec7bad15ed1809125816b2821c.png";